import CustomSectionHeader from './CustomSectionHeader';

export default CustomSectionHeader;
